import { hrmsGet, hrmsPut } from "../api/api";


export const SETTINGS_VALUE_MAX_LENGTH = 100;



export async function fetchOrgSettings() {
  const response = await hrmsGet("/org-settings", "HR34S");
  return Array.isArray(response?.data) ? response.data : [];
}


export async function fetchOrgSettingsByCategory(settingsCategory) {
  const response = await hrmsGet(
    `/org-settings/category/${encodeURIComponent(settingsCategory)}`,
    "HR34S"
  );
  return Array.isArray(response?.data) ? response.data : [];
}


export async function updateOrgSetting(settingsKey, settingsValue) {
  const response = await hrmsPut(
    `/org-settings/update/${encodeURIComponent(settingsKey)}`,
    { settingsValue: settingsValue ?? "" },
    "HR34U"
  );
  return response?.data ?? null;
}

export const orgSettingsService = {
  fetchOrgSettings,
  fetchOrgSettingsByCategory,
  updateOrgSetting,
  SETTINGS_VALUE_MAX_LENGTH,
};

export default orgSettingsService;
